export default {
  logs: 'Logs',
}
